
import { defineComponent, PropType, ref } from "vue";

import {
  BaseTable,
  ColumnDefinition,
  FormFieldComboBox,
  OptionType,
} from "@tager/admin-ui";
import { Nullable } from "@tager/admin-services";

import { createProductTable } from "@/views/BasisProductForm/BasisProductForm.helpers";
import { BasisProductParam } from "@/typings/model";

type Props = Readonly<{
  params: Array<BasisProductParam>;
  products: Array<{
    options: Array<{
      id: Nullable<number>;
      name: string;
    }>;
    product: Nullable<OptionType<number>>;
  }>;
  productSearchListOption: Array<OptionType<number>>;
}>;

export default defineComponent({
  name: "ProductTable",
  components: {
    FormFieldComboBox,
    BaseTable,
  },
  props: {
    params: {
      type: Array as PropType<Props["params"]>,
      required: true,
    },
    products: {
      type: Array as PropType<Props["products"]>,
      required: true,
    },
    productSearchListOption: {
      type: Array,
      required: true,
    },
    handleProductSearchQueryChange: {
      type: Function,
      required: true,
    },
    noProductOptionsMessage: {
      type: String,
      required: true,
    },
    isProductLoading: {
      type: Boolean,
      required: true,
    },
  },

  setup(props) {
    const COLUMN_DEFS: Array<ColumnDefinition> = createProductTable(
      props.params
    );

    const isOpen = ref<boolean>(false);

    function toggleOptionTable() {
      isOpen.value = !isOpen.value;
    }

    return {
      columnDefs: COLUMN_DEFS,
      isOpen,
      toggleOptionTable,
    };
  },
});
